'use client'
import { toast } from "@/hooks/use-toast"
import useCommonStore from "@/store/commonStore"
import useWishListStore from "@/store/wishListStore"
import { Trash2 } from "lucide-react"
import { useEffect, useState } from "react"
import { Button } from "@/components/ui/button"
import { useRouter } from "next/navigation"
import useCartStore, { ICartItem } from "@/store/cartStore"
import { GTMAddToCartHandler, GTMRemoveFromCartHandler, GTMRemoveFromWishlistHandler, GTMViewWishlistHandler } from "@/lib/analytics"

export default function Wishlist() {
  const [loading, setLoading] = useState(false)
  // const [wishList, setWishList] = useState<{ [key: string]: any }[]>([])
  const { cartDetails, cart, updateCart } = useCartStore()
  const { fetchWishList, updateWishList, profileWishLists } = useWishListStore()
  const { isAuth ,translations} = useCommonStore()
  const router = useRouter()
  useEffect(() => {

    loadDetails()

  }, [])

  const loadDetails = async () => {
    setLoading(true)
    const result = await fetchWishList()
    setLoading(false)
    let itm=result.data?.list.map((item:any)=>({
      item_id:item?.pdt_id,
      item_variant:item?.variant_id,
      item_name:item?.pdt_nm,
      price:item?.spl_prc_in_num,
      
    }))
    console.log(itm);
    
    GTMViewWishlistHandler({
      items:itm
    })
    if (result?.status) {
      // setWishList(result.data?.list || [])
    } else {
      toast({
        title: "Error",
        description: result?.error || "Something went wrong",
        variant: "destructive"
      })
    }
  }
  const handleDelete = async (pdt_id: string,pdt_nm:string,variant_id:string,price:number) => {
    setLoading(true)
    let reqObj = {
      pdt_id,
      flag: false
    }
    GTMRemoveFromWishlistHandler({
      items:[
      {  item_id:pdt_id,
        item_name:pdt_nm,
        price:price,
        item_variant:variant_id
      }
      ]
    })
    const result = await updateWishList(reqObj, isAuth);
    setLoading(false)
    if (result.status) {
      toast({
        variant: "default",
        title: "Success",
        description: result.message,
      })
    } else {
      toast({
        variant: "destructive",
        title: "Error",
        description: result.error,
      })
    }
  };
  const cartHandler = async (item: ICartItem, mxq: number, type: string,spl_prc: number,pdt_nm: string) => {
    if (type === "increment") {
      GTMAddToCartHandler({
        value: spl_prc,
        items: [
          {
            item_id: item.pdt_id,
            item_variant: item.variant_id,
            quantity: item.quantity,
            price: spl_prc,
            item_name: pdt_nm ? pdt_nm : "",

          }]
      })
    }
    else if (type === "decrease") {
      GTMRemoveFromCartHandler({
        value: spl_prc,
        items: [
          {
            item_id: item.pdt_id,
            item_variant: item.variant_id,
            quantity: item.quantity,
            price: spl_prc,
            item_name: pdt_nm ? pdt_nm : "",
          }]
      });
    }
    const update = await updateCart(item, mxq, isAuth);
    if (update?.status) {
      toast({ variant: "default", title: "Cart updated", description: update.message });
      await loadDetails()
    } else {
      toast({ variant: "destructive", title: update?.message, description: update?.error });
    }
  };
  const navigateToProduct = (slug: string, pdt_id: string, variant_id?: string) => {
    router.push(`/products/${slug}?pdt_id=${pdt_id}&variant_id=${variant_id}`)
  }

  return (
    <div>
      <h1 className="text-3xl md:text-6xl font-bold text-chart-3 mb-4 md:mb-8 hidden md:block">{translations["wishlist"]||  "Wishlist"}</h1>
      {profileWishLists?.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-8">
          {profileWishLists.map(item => (
            <div key={item.id}
              onClick={() => navigateToProduct(item.slug, item.pdt_id, item.variant_id)}
              className="bg-white rounded-xl shadow p-4 relative group">
              <button className="absolute top-3 right-3 bg-white border border-gray-300 rounded-full p-1 hover:bg-gray-100 transition rtl:left-3 rtl:right-auto">
                <Trash2 className="w-5 h-5 text-gray-500"
                  onClick={(e) => {
                    e.stopPropagation()
                    handleDelete(item.pdt_id,item.pdt_nm,item?.variant_id ,item?.spl_prc_in_num)
                  }}
                />
              </button>
              <img src={`${item.thumbnail}?h=300`} alt={item.pdt_nm} className="w-full h-48 object-contain mb-4 rounded" />
              <div className="mb-2">
                {item.rating > 0 && <span className="inline-block bg-[#FFF7E7] text-primary text-xs font-semibold px-2 py-1 rounded mr-2">
                  {item.rating} <span className="text-yellow-500">★</span>
                </span>}
              </div>
              <div className="font-medium text-base mb-2">{item.pdt_nm}</div>
              {item?.in_stk ? (<span className="text-green-600 font-semibold text-sm mb-2 block">{translations["in_stock"] || "In Stock"}</span>
              ) : (
                <span className="text-red-600 font-semibold text-sm mb-2 block">{translations["out_of_stock"] || "Out of Stock"}</span>
              )}
              <div className="flex items-center gap-2 mb-2">
                <span className="font-bold text-lg">{item.spl_prc}</span>
                {item.price!= item.spl_prc && <span className="text-gray-400 line-through">{item.price}</span>}
                {item.discount && item.originalPrice != item.price && <span className="text-green-600 text-sm font-semibold">({item.discount})</span>}
              </div>
              {(() => {
                const match = cart?.find(i => i.pdt_id === item?.pdt_id || (item.variant_id && i.variant_id === item.variant_id));
                return (
                  <div>
                    {match ? (
                      <button
                      disabled={!item.in_stk}
                        onClick={(e) => {e.stopPropagation() ,e.preventDefault() ,router.push("/mycart")}}
                        className="w-full bg-green-600 text-white py-2 rounded mt-2 hover:bg-green-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        {translations["go_to_cart"]||"Go to Cart"}
                      </button>
                    ) : (
                      <button
                             disabled={!item.in_stk}
                        onClick={(e) => {
                          e.preventDefault()
                          e.stopPropagation()
                          cartHandler(
                            { pdt_id: item.pdt_id, variant_id: item?.variant_id || "", quantity: 1 },
                            item.max_order_quantity,
                            "increment",
                            item.spl_prc_in_num,
                            item.pdt_nm
                          )
                        }}
                        className="w-full bg-primary text-white py-2 rounded mt-2 hover:bg-[#4d2d0e] transition disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        {translations["mov_to_cart"]||"Move to Cart"}
                      </button>
                    )}
                  </div>
                );
              })()}
              {/* <button onClick={() => cartHandler({ pdt_id: item.pdt_id, variant_id: item.variant_id, quantity: 1 }, item.max_order_quantity)} className="w-full bg-primary text-white py-2 rounded mt-2 hover:bg-[#4d2d0e] transition">
                Move to cart
              </button> */}
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center">
          <figure className="w-[300px] m-auto mb-[20px]">
            <img src="https://curlified.com/assets/wishlist.4ffd6550.png" alt="empty wishlist" className="cf-img-cover" />
          </figure>
          <p className="text-lg mb-[30px]">{translations["empty_wishlist"]||"Your wishlist is empty."}</p>
          <Button onClick={() => router.push("/products")} className="bg-primary text-white">{translations["shop_now"]||"Shop Now"}</Button>
        </div>
      )}
    </div>
  )
}